import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AppActionItem, ApplicationDTO, HekaAccountMenu, HekaNavigationContainerComponent} from "ngx-heka-design-lib";
import {environment} from "../../../environments/local/environment";
import {Subscription} from "rxjs";
import {LoadingService} from "../../services/loading/loading.service";
import {AccountMenuService} from "../../services/account-menu.service";
import {MultiDomainMgmtService} from "../../services/multi-domain-mgmt.service";
import {UserMgmtService} from "../../services/user-mgmt.service";
import {TranslatePipe} from "@ngx-translate/core";
import {ApplicationService} from "../../services/application.service";
import {DomainHandlerService} from "../../services/domain-handler-service";
import {L1L3AuthService} from "ngx-auth-util-lib";
import {MatomoConfigService} from "../../services/matomo-config.service";
import {MatomoTracker} from "ngx-matomo-client";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'ngx-l2-multi-org-menu',
  imports: [
    HekaNavigationContainerComponent,
    TranslatePipe,
    AsyncPipe
  ],
  templateUrl: './l2-multi-org-menu.component.html',
  standalone: true,
  styleUrl: './l2-multi-org-menu.component.scss'
})
export class L2MultiOrgMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  helpLink = environment.links.help;
  hcpLink = environment.links.applications.hcp;

  appMenuItems: AppActionItem[] = [];
  accountMenu?: HekaAccountMenu;

  applications!: ApplicationDTO[];
  isL3Access = false;

  private subscriptions = new Subscription();
  private profileSubscription?: Subscription;

  constructor(
    public loadingService: LoadingService,
    public accountMenuService: AccountMenuService,
    private multiDomainMgmtService: MultiDomainMgmtService,
    private userMgmtService: UserMgmtService,
    private applicationService: ApplicationService,
    public domainHandlerService: DomainHandlerService,
    public authService: L1L3AuthService,
    public matomoConfigService: MatomoConfigService,
    public matomoTracker: MatomoTracker
  ) {
  }


  ngOnInit(): void {
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile(true).subscribe({
        next: profile => {
          if (profile) {
            this.accountMenu = this.accountMenuService.buildAccountMenu(profile);
          }
        }
      })
    );

    this.subscriptions.add(
      this.userMgmtService.userInfoChanged.subscribe({
        next: userInfo => {
          if (userInfo) {
            this.isL3Access = !!this.authService.getL3Token();

            if (this.isL3Access) {
              this.getProfile();
            }
          }
          this.multiDomainMgmtService.updateMultiDomainProfile();
        }
      })
    );
  }

  ngAfterViewInit(): void {
    const helpLinkButton = document.getElementById('sel-menu-help-btn');

    if (helpLinkButton) {
      helpLinkButton.addEventListener('click', this.onHelpLinkClick.bind(this));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.profileSubscription?.unsubscribe();
  }

  onHelpLinkClick(event: Event): void {
    this.matomoTracker.trackLink(this.helpLink, 'link');
  }

  openHcp = () => {
    window.location.href = this.hcpLink;
  }

  private setupApplicationsMenu() {
    this.appMenuItems = this.applicationService.generateApplicationMenu(this.applications);
    if (this.appMenuItems.findIndex(item => item.config.isCurrentApp) < 0) {
      this.authService.logout();
    }
  }

  private getProfile() {
    this.loadingService.setLoading(true);
    this.profileSubscription?.unsubscribe();
    this.profileSubscription = this.userMgmtService.getSharedProfile().subscribe({
      next: profile => {
        if (profile) {
          if (profile.applications?.length > 0) {
            this.applications = profile.applications;
          } else {
            this.applications = [];
          }
          this.setupApplicationsMenu();
        }
        this.loadingService.setLoading(false);
      },
      error: err => {
        this.loadingService.setLoading(false);
        throw err;
      }
    });
  }

}

